import { render, staticRenderFns } from "./ym-drug.vue?vue&type=template&id=374eafee&scoped=true&"
import script from "./ym-drug.vue?vue&type=script&lang=js&"
export * from "./ym-drug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374eafee",
  null
  
)

export default component.exports